import { createAction } from '@reduxjs/toolkit';

export const selectAllElementsOfType = createAction(
  'selection/SELECT_ALL_ELEMENTS_OF_TYPE',
  ({ elementType, projectId }: { elementType: 'Image' | 'Text' | 'Shape' | 'Camera'; projectId: number }) => {
    return {
      payload: { elementType, projectId }
    };
  }
);
